import React, { Component } from 'react'

export default class Info extends Component {
  render() {
    const { text } = this.props
    return (
      <div className="text-start text-red-800 my-5">
        <div
          className="text-start pl-2 "
          dangerouslySetInnerHTML={{__html: text}}
        />
      </div>
    )
  }
}
